const {
  IS_LOADING,
  REPORT_LIST_SUCCESS,
  REPORT_LIST_ERROR,
  REPORT_DOWNLOAD_SUCCESS,
  REPORT_DOWNLOAD_ERROR,
  REPORT_GET_DOWNLOAD_FILES_SUCCESS,
  REPORT_GET_DOWNLOAD_FILES_ERROR,
} = require("../actions/Type");

const initialState = {
  loading: false,
  report_list: {},
};

export const ReportManagementReducers = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case IS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case REPORT_LIST_SUCCESS:
      return {
        ...state,
        report_list: payload,
        loading: false,
      };
    case REPORT_LIST_ERROR:
      return {
        ...state,
        report_list: payload,
        loading: false,
      };
    case REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        report_downoad: payload,
        loading: false,
      };
    case REPORT_DOWNLOAD_ERROR:
      return {
        ...state,
        report_list: payload,
        loading: false,
      };
    case REPORT_GET_DOWNLOAD_FILES_SUCCESS:
      return {
        ...state,
        report_download_files: payload || [],
        loading: false,
      };
    case REPORT_GET_DOWNLOAD_FILES_ERROR:
      return {
        ...state,
        report_download_files: payload || [],
        loading: false,
      };

    default:
      return state;
  }
};
